import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { Product } from "@/interfaces/domain/Product";
import { getProductByIdRequest } from "@/services/api/product";
import { logger } from "@/services/logger";
import { formatProductToOrderItem } from "@/utils/helpers";

export const useProductById = (id: string, options?: UseQueryOptions<Product>) => {
  const { data, isLoading } = useQuery<Product>({
    queryKey: [`/product-by-id/${id}`],
    queryFn: () => getProductByIdRequest(id),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });

  return {
    data: data ? formatProductToOrderItem(data) : null,
    isLoading,
  };
};
